<template>
  <div>
    <p v-if="label" class="top-label">
      {{ label }}
      <span v-if="required" class="reqstar">*</span>
    </p>
    <p v-if="helper_text">{{ helper_text }}</p>
    <label v-for="(option,index) in compOptions" :key="index">
      <input
        type="checkbox"
        :id="`checkbox_${index}`"
        @input="handleInputChange"
        :value="option.value"
      />
      <span>{{ option.label }}</span>
    </label>
    <label v-if="other">
      <input type="checkbox" value="other" :name="`checkbox_${_uid}`" @change="handleInputChange" />
      <span>{{ otherLabel }}</span>
    </label>
    <p v-if="isOtherSelected" class="other">
      <label :for="`select_other_${_uid}`">
        {{ otherLabel }}
        <br />
        <input type="text" :id="`select_other_${_uid}`" @input="handleValueChange" />
      </label>
    </p>
    <p v-if="error" class="validation-error">{{error}}</p>
  </div>
</template>

<script>
export default {
  name: "FormCheckbox",
  props: {
    label: {
      type: String,
      default: null
    },
    helper_text: {
      type: String,
      default: null
    },
    required: {
      type: Boolean,
      default: false
    },
    checked: {
      type: Boolean,
      default: false
    },
    error: {
      type: [String, Object]
    },
    options: {
      type: String,
      default: null
    },
    other: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localVal: [],
      otherLabel: "Other, please specify",
      isOtherSelected: false
    };
  },
  computed: {
    isChecked() {
      return this.checked || this.value > 0;
    }
  },
  methods: {
    handleInputChange(e) {
      if (e.target.value === "other") {
        this.isOtherSelected = true;
      } else {
        this.isOtherSelected = false;
      }
      if (e.target.checked) {
        this.localVal.push(e.target.value);
      } else {
        this.localVal = this.localVal.filter(val => val !== e.target.value);
      }
      this.$emit("input", this.localVal);
    },
    handleValueChange(e) {
      const currentInputs = this.localVal.slice(0, -1);
      const value = e.target.value;
      currentInputs.push(value);
      this.localVal = currentInputs;
      this.$emit("input", this.localVal);
    }
  },
  computed: {
    compOptions() {
      if (!this.options) {
        return [{ value: true, label: this.label }];
      }
      const optionArray = this.options.split("\n");
      const returnArr = optionArray.map(option => {
        const parts = option.split(":");
        return { value: parts[0], label: parts[1] };
      });
      return returnArr;
    }
  }
};
</script>

<style lang="scss" scoped>
label {
  display: flex;
  align-items: center;

  input {
    margin-right: 10px;
  }
}
.top-label {
  font-size: 1.25rem;
  line-height: 120%;
  margin-top: 0;
}

.other {
  label {
    font-size: 1.25rem;
    line-height: 1.2;
    padding-bottom: 0.5rem;
    display: inline-block;
    width: 100%;
  }
  input[type="text"] {
    padding: 10px;
    width: 100%;
    @media (min-width: 768px) {
      max-width: 50vw;
    }
  }
}
</style>